import type { IRemoveViewMicro, IRunPlan } from '../types';
import { RemoteView } from './remote_view';

/**
 * load a hosting application
 */
export class HostingRemoteView extends RemoteView {
  public runPlan: IRunPlan<IRemoveViewMicro>;

  /**
   * do nothing because we load a remote index
   */
  async writeHead() {
    return ``;
  }

  /**
   * do nothing because we load a remote index
   */
  async writeBody() {
    return ``;
  }

  /**
   *
   */
  async writeIndex(runPlan: IRunPlan, head: string, body: string) {
    return `${runPlan.remote_view.uri}/index.html`;
  }
}
